<template>
    <div class='Ganadas'>
    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- Tabla -->
            <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre Proyecto</th>
                    <th scope="col">Solicitante</th>
                    <th scope="col">Pais</th>
                    <th scope="col">Adjudicado</th>
                    <th scope="col">Inicio</th>
                    <th scope="col">
                        Entrega <font-icon :icon="icon_text" class="pointer" @click="ordenar()" style="color:blue"/>
                    </th>
                    <th scope="col" class="text-center">Archivo</th>
                    <th scope="col">Monto</th>
                    <th scope="col" class="text-center">Fondeado</th>
                    <th scope="col" class="text-center">Concesíon</th>
                    <th scope="col" >Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id_oferta" :class="f.reoferta == '1' ? 'table-warning' : ''">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}">
                            {{f.titulo_proyecto}}
                        </router-link>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col-sm-3">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-sm-9">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                    </td>
                    <td>
                        <img :src="getBandera(f.pais_region)" class="bandera">
                    </td>
                    <td>{{fechaFormat(f.fecha_adj)}}</td>
                    <td>{{fechaFormat(f.fecha_iniciop)}}</td>
                    <td>{{fechaFormat(f.fecha_cierre)}}</td>
                    <td>
                        <p class="text-center pointer" v-if="f.adjuntoOriginalOferta.length > 0">
                            <font-icon icon="file-pdf"  class="pdf" style="font-size:28px"
                            @click="descargarFile(f.adjuntoOriginalOferta)"/>
                        </p>
                        <p class="text-center" v-else>
                           Sin Adjunto
                        </p>
                    </td>
                    <td>
                        <p>${{moneda(f.costo)}} <small> ({{f.divisa}}) </small><br>
                        <span class="badge badge-warning" v-if="f.reoferta == '1'">
                            En re-oferta
                        </span>
                        <span class="badge badge-primary" v-if="f.reoferta == '0' && f.reofertado == 1">
                            Nueva oferta
                        </span></p>
                    </td>

                    <!--FONDEAR CONSULTOR-->
                    <td>
                        <div v-if="f.fondeado == 0">
                            <p class="text-center">
                                <font-icon icon="times" class="text-danger"/>
                            </p>
                        </div>
                        <div v-if="f.fondeado == 1">
                            <p class="text-center">
                                <font-icon icon="check" class="text-success"/>
                            </p>
                        </div>
                    </td>
                    <!--Concesion-->
                    <td>
                        <div v-if="f.fondeado == '1' && f.estatus_oferta != 7 && f.estatus_proyecto != 6">
                            <button class="btn btn-sm btn-success" @click="concluir(8,f)"> Entregar </button>
                        </div>
                        <div v-if="f.fondeado == '1' && f.estatus_oferta == 7">
                            Esperando Pago...
                        </div>
                        <div v-if="f.estatus_proyecto == 6">
                            <i style="color:orange">Pausado</i>
                        </div>
                    </td>

                    <!--ACCIONES -->
                    <td>
                        <!--<div v-if="f.fondeado == '0'" >-->
                        <div>
                            <button v-if="f.estatus_proyecto == 6" class="btn btn-sm btn-success" @click="quitarPausa(f)">
                                <font-icon icon="play"/>
                            </button>

                            <button v-if="f.estatus_oferta == 7" class="btn btn-sm btn-warning" disabled>
                                    <font-icon icon="pause"/>
                            </button>

                            <button v-if="f.estatus_proyecto != 6 && f.estatus_oferta != 7"
                                    class="btn btn-sm btn-warning"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Pausar Proyecto"
                                    @click="catchF(f)"
                                    >
                                    <font-icon icon="pause"/>
                            </button>

                            <button v-if="f.fondeado == '0'" class="btn btn-sm btn-danger"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Cancelar Proyecto"
                                    @click="catchID(f)"
                                    >
                                    <font-icon icon="times"/>
                            </button>
                            <button v-else class="btn btn-sm btn-danger" @click="cancelarDos(f)">
                               <font-icon icon="handshake"/>
                            </button>

                            <button class="btn orange btn-sm" @click="regChat(f)" title="Chat" >
                                <font-icon icon="comments"/>
                            </button>
                        </div>
                        <!--<div v-else>
                            <button class="btn btn-sm btn-warning" disabled>
                                <font-icon icon="pause"/>
                            </button>
                            <button class="btn btn-sm btn-danger" @click="cancelarDos()">
                               <font-icon icon="handshake"/> Conciliar
                            </button>
                            <button class="btn orange btn-sm" @click="regChat()">
                                <font-icon icon="comments"/>
                            </button>
                        </div>-->
                    </td>

                </tr>
            </tbody>
            </table>
        </div>
    </div>


    <!--Modal Pausa -->
    <div class="modal fade" id="modalSuspender" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Pausar el proyecto:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="altaRazonPausa">
                <div class="modal-body">
                    <h3 class="text-center">{{nombreProyecto}}</h3>

                    <div>
                        <textarea class="form-control" v-model="inputRazon" rows="5" required maxlength= "280"
                        placeholder="Indica la razón por la cúal pones en pausa el proyecto. Haremos llegar esta alerta a tu cliente."></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="submit" class="btn orange"> Aceptar </button>
                </div>
            </form>
            </div>
        </div>
    </div>

     <!--Modal Cancelar -->
    <div class="modal fade" id="modalCancelar" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Cancelación del Proyecto:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form @submit="cancelar">
                <div class="modal-body">
                    <div>
                        <h3 class="text-center">{{nombreProyecto}}</h3>
                        <textarea class="form-control" v-model="razonCancelacion" rows="5" required maxlength="100"
                        placeholder="Razon por cancelacion..."></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="submit" class="btn orange"> Aceptar </button>
                </div>
            </form>
            </div>
        </div>
    </div>

    <!--Modal Help Desk-->
    <div class="modal fade" id="helpdeskModal" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Solicitud de conciliacion para el proyecto:</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h3 class="text-center">{{nombreProyecto}}</h3>
                    <p>
                        Envíenos un correo para apoyarle en la gestión de Conciliacion del proyecto al siguiente correo:
                        <a href="ejemplo@gmail.com">
                            reconcilement@itsapp.com.mx
                        </a>
                    </p>
                    <p>Indicándonos: Nombre de Usuario, el correo electrónico con el que se registró en nuestra página y el nombre del proyecto,
                    dándonos una breve descripción de su solicitud.</p>
                </div>
            </div>
        </div>
    </div>

   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'
import $ from 'jquery'
export default {
name: 'Ganadas',
components:{ StarRating },
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true,
        inputRazon: '',
        razonCancelacion: '',
        idOferta: '',
        idProyecto: '',
        ordenarProp: 'ASC',
        icon_text: 'sort-up',
        nombreProyecto: ''
    }
},
methods: {

getData(){

    let data = {
        id: localStorage.userID,
        prop: 2,
        flag: 3,
        ordenarProp: this.ordenarProp
    };

    this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
        this.projectos = responce.data;
        this.loading = false
    });
},

regChat(f){
        let consultor = f.id_user;
        let proyecto = f.id_proyecto;

        let data = {
            flag: 0,
            idProyecto: proyecto,
            idEmpresa: consultor,
            idConsultor: localStorage.userID,
        }

        this.axios.post(this.url + 'altaChat.php', data).then((responce) =>{
            if(responce.data == 200){
                this.$router.push('/Blog?tabla=' + consultor + '&tabla2=' + proyecto);
            }
        })

},

ordenar(){
    if(this.ordenarProp == 'ASC'){
        this.ordenarProp = 'DESC'
        this.icon_text = 'sort-down';
    }else {
        this.ordenarProp = 'ASC'
        this.icon_text = 'sort-up';
    }

    this.getData(this.ordenarProp);
},

catchF(f){
    $('#modalSuspender').modal('show')
    this.idOferta = f.idOferta;
    this.idProyecto = f.id_proyecto;
    this.nombreProyecto = f.titulo_proyecto;
},

catchID(f){
    $('#modalCancelar').modal('show')
    this.idOferta = f.id_oferta;
    this.idProyecto = f.id_proyecto;
    this.nombreProyecto = f.titulo_proyecto;
},

quitarPausa(f){
    if(f.quienPauso == 1){
        alert("Proyecto pausado, < " + f.razonPausado + " >, para reanudar su ejecución contactar con el cliente.");
    }
    else{

        let data = {
            flag:6,
            num: 4, //status
            id: f.id_proyecto,
            razon: '',
            quien: '0',
        };
        
        this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
            if(responce.data == 200){
                this.msjOk("Proyecto Reanudado");
                this.getData();
            }
        });
    }
},

altaRazonPausa(e){
    e.preventDefault();

    let data = {
        flag:6,
        num:6, //status
        id: this.idProyecto,
        razon: this.inputRazon,
        quien: 0
    };

    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
        if(responce.data == 200){
            this.msjOk("Proyecto Pausado");
            this.enviarCorreo(18, 'Pausa proyecto en ejecución', this.idProyecto);
            this.getData();
            this.inputRazon = '';
            $('#modalSuspender').modal('hide');
        }else{
            alert("Error");
        }
    });
},

concluir(num,f){

    let data = {
        flag:0,
        num:num, //status
        id:f.id_proyecto,
        userID: localStorage.userID,
    };

    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
        if(responce.data == 200){
            this.enviarCorreo(19, 'Proyecto concluido', f.id_proyecto);
            this.msjOk("Proyecto Concluido");
            this.getData();
        }
    });
},

cancelarDos(f){
    $('#helpdeskModal').modal('show')
    this.nombreProyecto = f.titulo_proyecto;
},

cancelar(e){
    e.preventDefault();

    this.$swal.fire({
            title: '¿Estas Seguro?',
            text: "Ya no podras revertir el cambio!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cancelar proyecto'
            }).then((result) => {
                if (result.isConfirmed) {

                    let data = {
                        flag:7,
                        num:7, //status Proyecto
                        statusOferta: 5,
                        idProyecto: this.idProyecto,
                        idOferta: this.idOferta,
                        userType: '1', //Consultor
                        razon: this.razonCancelacion
                    };

                    this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
                        if(responce.data == 200){
                            this.getData();
                            this.$emit("update");

                            $('#modalCancelar').modal('hide');

                            this.$swal.fire(
                             'Cancelado!',
                             'Tu proyecto ha sido cancelado.',
                             'success'
                            );

                        }
                    });
                }
            })
}
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Proyectos/components/Consultor/Ganadas.vue